module.exports = __webpack_public_path__ + "img/ic-mailbox.14a64bc2.png";